import { watch } from "vue";
import { useFormStore } from "@/features/blueprint/stores/useFormStore";
import { useScoreStore } from "@/features/blueprint/stores/useScoreStore";
import { QuestionSchema } from "@/features/blueprint/schema/questions/QuestionSchema";
import { Answers } from "@/features/blueprint/schema/answers/Answers";

interface LifecycleDeps {
    formStore: ReturnType<typeof useFormStore>;
    scoreStore: ReturnType<typeof useScoreStore>;
    questionSchema: { value: QuestionSchema[] };
}

export function useBlueprintLifecycle({ formStore, scoreStore, questionSchema: rawSections }: LifecycleDeps) {
    formStore.setSections(rawSections.value);
    formStore.loadFromLocalStorage();
    scoreStore.recalculate();

    watch(
        () => formStore.answers,
        (newAnswers: Answers) => {
            scoreStore.recalculate();
        },
        { deep: true }
    );
}
